window.ttx = window.ttx || {};
ttx.bill = {};

ttx.bill.list = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/list' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('查询成功');
            callback(res);
        },
        fail: (err) => {
            ttx.log.error('查询失败');
            callback(err);
        }
    })
}

ttx.bill.detail = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/detail' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('查询成功');
            callback(res);
        },
        fail: (err) => {
            ttx.log.error('查询失败');
            callback(err);
        }
    })
}

ttx.bill.add = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/add' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('添加成功');
            callback(res);
        },
        fail: (err) => {
            ttx.log.error('添加失败');
            callback(err);
        }
    })
};

ttx.bill.save = function (props, params, data, callback) {
    const recordId = data.data?.id || data.id;
    if (!recordId) {
        ttx.bill.add(props, params, data, callback);
        return;
    }
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/save' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('保存成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('保存失败');
            callback(err);
        }
    })
};

ttx.bill.delete = function (props, params, data, callback) {
    ttx.modal.confirm({
        title: '确定要删除吗？',
        content: '删除后将无法恢复',
        onConfirm: () => {
            let query = ttx.utils.transferQuery(params);
            ttx.ajax.xhrUtil({
                url: '/api/bill/delete' + query,
                method: 'post',
                data: data,
                success: (res) => {
                    ttx.log.success('删除成功');
                    callback(res.data);
                },
                fail: (err) => {
                    ttx.log.error('删除失败');
                    callback(err);
                }
            })
        }
    });
};

ttx.bill.edit = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/edit' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('编辑成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('编辑失败');
            callback(err);
        }
    })
};

ttx.bill.submit = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/submit' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('提交成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('提交失败');
            callback(err);
        }
    })
};

ttx.bill.approve = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/approve' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('审批成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('审批失败');
            callback(err);
        }
    })
};

ttx.bill.reject = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/reject' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('驳回成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('驳回失败');
            callback(err);
        }
    })
};

ttx.bill.withdraw = function (props, params, data, callback) {
    let query = ttx.utils.transferQuery(params);
    ttx.ajax.xhrUtil({
        url: '/api/bill/withdraw' + query,
        method: 'post',
        data: data,
        success: (res) => {
            ttx.log.success('撤回成功');
            callback(res.data);
        },
        fail: (err) => {
            ttx.log.error('撤回失败');
            callback(err);
        }
    })
};

ttx.bill.print = function (props, params, data, callback) {
    window.print();
    callback?.();
};

// 挂载详情页面方法
ttx.bill.load = function (option) {
    const { panel, params, callback } = option;
    let data = { params: { ...params } };
    if (panel == 'bill') {
        if (params.billtype == 'card') {
            ttx.bill.detail(null, params, data, callback);
        } else {
            ttx.bill.list(null, params, data, callback);
        }
    }
};
